<template>
  <div class="bulk-tp-selection-container">
    <div
      class="bulk-tp-selection-type"
      @click="setType('line')"
      :class="{ active: selectionType === 'line' }"
    >
      <div style="height: 18px">
        <BulkTPLineSVG :class="{ active_svg: selectionType === 'line' }" />
      </div>
      <div class="bulk-tp-text">{{ $tc("Line", 1) }}</div>
    </div>
  </div>
</template>

<script>
import BulkTPLineSVG from "@/assets/bulk_tp_svgs/bulk_tp_line.svg";

export default {
  name: "BulkTPCreationTypeButtons",

  props: {
    selectionType: {
      type: String,
      required: true
    },
    creatable: {
      type: Boolean
    }
  },

  components: {
    BulkTPLineSVG,
  },

  methods: {
    /**
     * Sets the type of bulk creation
     */
    setType(type) {
      this.$emit("setType", type);
    }
  }
};
</script>

<style scoped>
.bulk-tp-selection-type {
  height: 40px;
  width: 50px;
  background-color: #f5f5f5;
  margin-right: 16px;
  border: 0.5px solid #bcbcbc;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #515358;
  cursor: pointer;
}

.bulk-tp-selection-type.active {
  background-color: #d4e9ee;
  border: 0.5px solid var(--primary-highlight);
}

.bulk-tp-selection-type.active .bulk-tp-text {
  color: var(--primary-highlight);
}

.bulk-tp-text {
  padding-top: 1px;
}

.bulk-tp-selection-container {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 20px;
}

.active_svg * {
  fill: var(--primary-highlight);
  stroke: var(--primary-highlight);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/BulkTP/BulkTPCreationTypeButtons.vue